import ContactMe from "./YogaContactMe";
import YogaNavBar from "./YogaNavBar";

export default function ContactMePage() {
    return (
        <>
        <YogaNavBar />
        <ContactMe />
        </>
    )
}
